// extracted by mini-css-extract-plugin
export default {"tellusform":"TellUsForm_tellusform__EuuI3","formcontent":"TellUsForm_formcontent__FcWKs","skipperson":"TellUsForm_skipperson__aHJ2-"};